import React from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function DeviceAccessWarningModal({
  show,
  result,
  onConfirm,
}) {
  const slotLabel = result?.slotLabel || "อุปกรณ์";
  const deviceCount = Number(result?.deviceCount || 0);
  const warningLevel = Number(result?.warningLevel || 0);
  const isHighRisk = warningLevel >= 2;

  return (
    <Modal
      show={!!show}
      onHide={onConfirm}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>การเข้าใช้งานเว็บไซต์</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* <Alert variant={isHighRisk ? "danger" : "warning"} className="mb-3">
          ตรวจพบการเข้าใช้งานจากอุปกรณ์ประเภท{" "}
          <strong>{slotLabel}</strong> มากกว่าหนึ่งเครื่อง
        </Alert>

        <p className="mb-2">
          ขณะนี้ระบบพบข้อมูลการเข้าใช้งานอุปกรณ์ประเภท{" "}
          <strong>{slotLabel}</strong> รวมประมาณ{" "}
          <strong>{deviceCount}</strong> เครื่อง
        </p>

        <p className="mb-2">
          ข้อมูลนี้จะถูกบันทึกไว้เพื่อความปลอดภัยของบัญชี
          และเพื่อป้องกันการใช้งานผิดเงื่อนไขของเว็บไซต์
        </p> */}
        <Alert variant={isHighRisk ? "danger" : "warning"} className="mb-3">
          ระบบได้บันทึกข้อมูลการเข้าใช้งานจากอุปกรณ์ประเภท{" "}
          <strong>{slotLabel}</strong>
        </Alert>

        <p className="mb-2">
          ข้อมูลทางเทคนิคของอุปกรณ์ที่ใช้เข้าใช้งานอาจถูกบันทึกไว้
          เพื่อช่วยรักษาความปลอดภัยของบัญชีผู้ใช้งาน
          และเพื่อป้องกันการใช้งานที่ผิดปกติ
        </p>

        <p className="mb-2">
          หากท่านเป็นเจ้าของบัญชีและใช้งานตามปกติ
          สามารถใช้งานเว็บไซต์ต่อได้ตามปกติ
        </p>

        <p className="mb-0 small text-secondary">
          กรุณาอ่าน{" "}
          <Link to="/terms" target="_blank" rel="noreferrer">
            ข้อกำหนดและเงื่อนไขการให้บริการ
          </Link>{" "}
          ของเว็บไซต์เพิ่มเติม
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onConfirm}>
          บันทึกข้อมูลเข้าใช้งาน
        </Button>
      </Modal.Footer>
    </Modal>
  );
}